/**
 * frontend/src/pages/PrivacyPage.js
 */
import styles from './PrivacyPage.module.css';

export default function PrivacyPage() {
  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <p className={styles.meta}>vakya.globalvedic.net/privacy</p>
        <h1 className={styles.title}>Privacy Policy</h1>
        <p className={styles.subtitle}>Vākya — Classical Sanskrit &amp; Telugu Verse · Last updated: March 14, 2026</p>

        <div className={styles.lead}>
          Vākya is a read-only classical literature reference app. We do not collect personal
          information, require account creation, or track your identity.
        </div>

        <h2>Information we collect</h2>
        <p>We collect minimal, anonymous data to operate the service:</p>
        <ul>
          <li><strong>Search queries</strong> — anonymous search terms are logged to improve search quality. No user identity is attached.</li>
          <li><strong>App preferences</strong> — display preferences (theme, script, font size) are stored locally on your device. They never leave your device.</li>
          <li><strong>Anonymous session ID</strong> — a random session identifier (not linked to any personal data) is generated per session to help diagnose technical issues.</li>
        </ul>

        <h2>Information we do not collect</h2>
        <ul>
          <li>Name, email address, or any account credentials</li>
          <li>Location data or GPS coordinates</li>
          <li>Device identifiers (IDFA, IDFV)</li>
          <li>Browsing history or verse reading history</li>
          <li>Payment information</li>
          <li>Camera, microphone, contacts, or photos</li>
          <li>Spiritual or religious beliefs</li>
        </ul>

        <h2>How we use your data</h2>
        <p>Anonymous search logs are used solely to improve search relevance and identify corpus gaps.
        We do not sell, share, or transfer any data to third parties. We do not use data for advertising.</p>

        <h2>Third-party services</h2>
        <ul>
          <li><strong>Anthropic Claude API</strong> — the Sūta Oracle feature sends your philosophical question to Anthropic's API. Questions are not stored by Vākya. <a href="https://www.anthropic.com/privacy" target="_blank" rel="noopener noreferrer">Anthropic's privacy policy</a> applies.</li>
          <li><strong>Amazon Web Services</strong> — our API and corpus database run on AWS infrastructure in the US-East-1 region. AWS does not have access to your search queries.</li>
          <li><strong>Expo</strong> — the app is built with Expo. Expo may collect anonymous crash and performance data per their <a href="https://expo.dev/privacy" target="_blank" rel="noopener noreferrer">privacy policy</a>.</li>
        </ul>

        <h2>Data retention</h2>
        <p>Anonymous search logs are retained for up to 90 days for quality improvement, then deleted.
        Local device preferences persist until you uninstall the app.</p>

        <h2>Children's privacy</h2>
        <p>Vākya is rated 4+ and suitable for all ages. We do not knowingly collect any information
        from children. No account creation is required to use the app.</p>

        <h2>Your rights</h2>
        <p>Since we do not collect personal data linked to your identity, there is nothing to access,
        correct, or delete. You may clear local app preferences at any time from the Settings screen.</p>

        <h2>Changes to this policy</h2>
        <p>We will update this policy if our data practices change. The latest version is always
        available at vakya.globalvedic.net/privacy.</p>

        <h2>Contact</h2>
        <p>Questions about this privacy policy: <a href="mailto:privacy@globalvedic.net">privacy@globalvedic.net</a></p>
        <p className={styles.address}>Global Vedic · Katy, Texas, USA</p>
      </div>
    </div>
  );
}
